@if (label()) {
  <div
    [id]="id() + '-label'"
    [class.text-error]="control().invalid && control().touched"
  >
    {{ label() }}
    @if (isRequired()) {
      <span class="ml-1">*</span>
    }
  </div>
}

<mat-radio-group
  [ngClass]="displayInline ? 'flex flex-col' : ''"
  [attr.aria-labelledby]="
    ariaLabelledBy() || (label() ? id() + '-label' : null)
  "
  [attr.aria-label]="
    (ariaLabelledBy() || label()) ? null : 'Seleziona opzione'
  "
  [attr.aria-required]="isRequired()"
  [formControl]="control()"
>
  @for (item of data(); track item?.id) {
    <mat-radio-button
      [value]="item?.id"
      [disabled]="item.disabled"
      [attr.id]="id() + item.id"
      [attr.name]="id() + item.id"
      [aria-label]="item.name"
    >
      <span [ngClass]="labelClass()">
        {{ item.name }}
      </span></mat-radio-button
    >
  }
</mat-radio-group>
<mat-error siatErrorField [control]="control()" [label]="label()"></mat-error>
